export default "__VITE_ASSET__CAVAFLhc__"